import {
  SET_CART_DETAIL,
  SET_HOME_BRAND,
  SET_MENU,
  SET_ORDER_SUCCESS,
  SET_VERSION_MENU,
  SET_SERVING_CONTEXT,
  SET_IS_NEED_REFRESH_MENU,
  SET_IS_REFRESH_PAGE,
  SET_IS_BF_PENDING_DISH,
  SET_KALO_GROUP_PENDING,
  SET_QUANTITY_FOOD_WASTED,
  SET_IS_SHOW_MESSAGE,
  SET_CURRENT_LANGUAGE,
  SET_OUT_OF_DISH_VERSION,
  SET_BUFFET_ITEM,
  SET_ALC_ITEM,
  SET_TAB_ACTIVE,
  SET_POSITION_SCROLL,
  SET_IS_HIDE_PRICE,
  SET_LIST_SESSION,
  SET_BUFFET_TICKET,
  SET_IS_CHECK_COMMENT,
  SET_TIP_TOP_DOWN,
  SET_BF_EXTRA_COUNT_CHILDREN,
  FW_SUBMIT_FOR_ROUND_DEFAULT,
  FW_SUBMIT_FOR_LESS_THAN_THREE_GUEST,
  SET_SHOW_TAB_ON_CART,
  SET_DATA_INFO_VAT,
  SET_DATA_INFO_USER_TGS,
  SET_DATA_USER_SESSION,
  SET_PAYMENT_PARTNER,
  FUNC_SHOW_PAYMENT_QR_ORDER,
  SET_DRAFT_HOME_BRAND,
  SET_IS_POINT_ONEMOUNT,
  SET_FEEDBACK_CONFIG,
  SET_FEEDBACK_CONFIG_CONTENT,
  SET_SIZE_IN_HOME,
  SET_VERTICAL_LAYOUT_QR_ORDER,
  SHOW_TOTAL_PRICE_APPLY_DISCOUNT,
  TIP_SUGGEST_BY_PERCENT,
  COMBO_CUSTOM_PRICE,
  COMBO_CUSTOM_PRICE_ONLY_SELECT,
  API_ERROR_UPDATE,
  API_ERROR_OPEN,
  NO_INTERNET,
  API_ERROR_PUSH,
  SET_PARAMS_HOTPOT_BF,
  SET_IS_BF_MENU,
  SET_HOTPOT_GUIDELINE_DISPLAYED,
  SET_ORDER_OVERVIEW,
  HOTPOT_SELECTING,
  HIDDEN_FREE_SOUP,
  ONBOARDING_URL,
  SET_COMENUGROUP_HOTPOT,
  SET_MAXIMUM_DISHES_BEING_SERVED,
  FUNC_SHOW_TIPPING,
  TIP_SUGGEST_BY_PERCENT_HIGH,
  TIP_TOP_DOWN_HIGH,
  USER_DEFAULT_OPEN_TABLE_QR_STATIC,
  VISIBLE_MENU_BY_WEEKDAYS,
  VISIBLE_MENU_BY_SPECIAL_DAYS,
  SET_TAKE_TAX,
  SET_INFO_TGS_V3,
  ALLOW_EXPEDITE_FULL_ORDER,
  TABLE_CODE,
  SET_PARAM_CONFIG,
} from "../types";
export const setTakeTax = (payload) => {
  return {
    type: SET_TAKE_TAX,
    payload: payload,
  };
};
export const setParamConfig = (payload) => {
  return {
    type: SET_PARAM_CONFIG,
    payload: payload,
  };
};
export const setCartDetail = (payload) => {
  return {
    type: SET_CART_DETAIL,
    payload: payload,
  };
};
export const setHomeBrand = (payload) => {
  return {
    type: SET_HOME_BRAND,
    payload: payload,
  };
};

export const setOrderSuccess = (payload) => {
  return {
    type: SET_ORDER_SUCCESS,
    payload: payload,
  };
};

export const setMenu = (payload) => {
  return {
    type: SET_MENU,
    payload: payload,
  };
};
export const setMenuVersion = (payload) => {
  return {
    type: SET_VERSION_MENU,
    payload: payload,
  };
};
export const setServingContext = (payload) => {
  return {
    type: SET_SERVING_CONTEXT,
    payload: payload,
  };
};
export const setIsNeedRefreshMenu = (payload) => {
  return {
    type: SET_IS_NEED_REFRESH_MENU,
    payload: payload,
  };
};

export const setIsRefreshPage = (payload) => {
  return {
    type: SET_IS_REFRESH_PAGE,
    payload: payload,
  };
};

export const setIsBfPending = (payload) => {
  return {
    type: SET_IS_BF_PENDING_DISH,
    payload: payload,
  };
};

export const setKaloGroupPending = (payload) => {
  return {
    type: SET_KALO_GROUP_PENDING,
    payload: payload,
  };
};
export const setQuantityFoodwasted = (payload) => {
  return {
    type: SET_QUANTITY_FOOD_WASTED,
    payload: payload,
  };
};
export const setCurrentLanguage = (payload) => {
  return {
    type: SET_CURRENT_LANGUAGE,
    payload: payload,
  };
};

export const setOutofDishVersion = (payload) => {
  return {
    type: SET_OUT_OF_DISH_VERSION,
    payload: payload,
  };
};

export const setBuffetItem = (payload) => {
  return {
    type: SET_BUFFET_ITEM,
    payload: payload,
  };
};

export const setAlcItem = (payload) => {
  return {
    type: SET_ALC_ITEM,
    payload: payload,
  };
};
export const setActiveTab = (payload) => {
  return {
    type: SET_TAB_ACTIVE,
    payload: payload,
  };
};

export const setPositionScroll = (payload) => {
  return {
    type: SET_POSITION_SCROLL,
    payload: payload,
  };
};

export const setIsHidePrice = (payload) => {
  return {
    type: SET_IS_HIDE_PRICE,
    payload: payload,
  };
};
export const setListSession = (payload) => {
  return {
    type: SET_LIST_SESSION,
    payload: payload,
  };
};
export const setBfExtraTicket = (payload) => {
  return {
    type: SET_BUFFET_TICKET,
    payload: payload,
  };
};
export const setIsCheckComment = (payload) => {
  return {
    type: SET_IS_CHECK_COMMENT,
    payload: payload,
  };
};
export const setTipTopDown = (payload) => {
  return {
    type: SET_TIP_TOP_DOWN,
    payload: payload,
  };
};
export const setBFextraCountChild = (payload) => {
  return {
    type: SET_BF_EXTRA_COUNT_CHILDREN,
    payload: payload,
  };
};
export const setSubmitForRoundDefault = (payload) => {
  return {
    type: FW_SUBMIT_FOR_ROUND_DEFAULT,
    payload: payload,
  };
};
export const setSubmitForLessThanThreeGuest = (payload) => {
  return {
    type: FW_SUBMIT_FOR_LESS_THAN_THREE_GUEST,
    payload: payload,
  };
};
export const setShowTabOnCart = (payload) => {
  return {
    type: SET_SHOW_TAB_ON_CART,
    payload: payload,
  };
};
export const setInfoVat = (payload) => {
  return {
    type: SET_DATA_INFO_VAT,
    payload: payload,
  };
};
export const setInfoUserTgs = (payload) => {
  return {
    type: SET_DATA_INFO_USER_TGS,
    payload: payload,
  };
};
export const setUserSession = (payload) => {
  return {
    type: SET_DATA_USER_SESSION,
    payload: payload,
  };
};
export const setPaymentPartnerSelected = (payload) => {
  return {
    type: SET_PAYMENT_PARTNER,
    payload: payload,
  };
};
export const setFuncShowPayment = (payload) => {
  return {
    type: FUNC_SHOW_PAYMENT_QR_ORDER,
    payload: payload,
  };
};
export const setDraftHomeBrand = (payload) => {
  return {
    type: SET_DRAFT_HOME_BRAND,
    payload: payload,
  };
};
export const setIsPointOnemount = (payload) => {
  return {
    type: SET_IS_POINT_ONEMOUNT,
    payload: payload,
  };
};
export const setFeedbackConfigDefault = (payload) => {
  return {
    type: SET_FEEDBACK_CONFIG,
    payload: payload,
  };
};
export const setShowContent = (payload) => {
  return {
    type: SET_FEEDBACK_CONFIG_CONTENT,
    payload: payload,
  };
};
export const setSizeInHome = (payload) => {
  return {
    type: SET_SIZE_IN_HOME,
    payload: payload,
  };
};
export const setVerticalLayoutQrOrder = (payload) => {
  return {
    type: SET_VERTICAL_LAYOUT_QR_ORDER,
    payload: payload,
  };
};
export const setTotalPriceApplyDiscount = (payload) => {
  return {
    type: SHOW_TOTAL_PRICE_APPLY_DISCOUNT,
    payload: payload,
  };
};
export const setTipPercent = (payload) => {
  return {
    type: TIP_SUGGEST_BY_PERCENT,
    payload: payload,
  };
};
export const setComboCustomPrice = (payload) => {
  return {
    type: COMBO_CUSTOM_PRICE,
    payload: payload,
  };
};
export const setComboCustomPriceOnlySelect = (payload) => {
  return {
    type: COMBO_CUSTOM_PRICE_ONLY_SELECT,
    payload: payload,
  };
};
export const setApiErrorData = (payload) => {
  return {
    type: API_ERROR_UPDATE,
    payload: payload,
  };
};
export const pushApiErrorData = (payload) => {
  return {
    type: API_ERROR_PUSH,
    payload: payload,
  };
};
export const setApiErrorOpen = (payload) => {
  return {
    type: API_ERROR_OPEN,
    payload: payload,
  };
};
export const setOpenNoInternetModal = (payload) => {
  return {
    type: NO_INTERNET,
    payload: payload,
  };
};
export const setDataParamsHotpotBF = (payload) => {
  return {
    type: SET_PARAMS_HOTPOT_BF,
    payload: payload,
  };
};
export const setIsBFMenu = (payload) => {
  return {
    type: SET_IS_BF_MENU,
    payload: payload,
  };
};
export const setHotpotGuidelineDisplayed = (payload) => {
  return {
    type: SET_HOTPOT_GUIDELINE_DISPLAYED,
    payload: payload,
  };
};
export const setOrderOverview = (payload) => {
  return {
    type: SET_ORDER_OVERVIEW,
    payload: payload,
  };
};
export const setHotpotSelecting = (payload) => {
  return {
    type: HOTPOT_SELECTING,
    payload: payload,
  };
};
export const setHiddenFreeSoup = (payload) => {
  return {
    type: HIDDEN_FREE_SOUP,
    payload: payload,
  };
};
export const setOnboardingUrl = (payload) => {
  return {
    type: ONBOARDING_URL,
    payload: payload,
  };
};
export const setCoMenuGroupHotpot = (payload) => {
  return {
    type: SET_COMENUGROUP_HOTPOT,
    payload: payload,
  };
};
export const setMaximumDishesBeingServed = (payload) => {
  return {
    type: SET_MAXIMUM_DISHES_BEING_SERVED,
    payload: payload,
  };
};
export const setIsShowTipping = (payload) => {
  return {
    type: FUNC_SHOW_TIPPING,
    payload: payload,
  };
};
export const setTipPercentHigh = (payload) => {
  return {
    type: TIP_SUGGEST_BY_PERCENT_HIGH,
    payload: payload,
  };
};
export const setTipTopDownHigh = (payload) => {
  return {
    type: TIP_TOP_DOWN_HIGH,
    payload: payload,
  };
};
export const setAutoCreateOrder = (payload) => {
  return {
    type: USER_DEFAULT_OPEN_TABLE_QR_STATIC,
    payload: payload,
  };
};
export const setVisibleMenuByWeekday = (payload) => {
  return {
    type: VISIBLE_MENU_BY_WEEKDAYS,
    payload: payload,
  };
};
export const setVisibleMenuBySpecialDay = (payload) => {
  return {
    type: VISIBLE_MENU_BY_SPECIAL_DAYS,
    payload: payload,
  };
};
export const setInfoTgsV3 = (payload) => {
  return {
    type: SET_INFO_TGS_V3,
    payload: payload,
  };
};
export const setExpedite = (payload) => {
  return {
    type: ALLOW_EXPEDITE_FULL_ORDER,
    payload: payload,
  };
};
export const setTableCode = (payload) => {
  return {
    type: TABLE_CODE,
    payload: payload,
  };
};
